import { motion } from 'framer-motion';
import { PROGRAMS } from './data';
// PROGRAMS — workout-log spec sheet style
export default function Programs({ setPage }) {
  return (
    <div className="bg-[#0A0A0A] text-white">
      <section className="pt-12 pb-8 max-w-[1500px] mx-auto px-6 lg:px-12 border-b border-[#F2C500]/30">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#F2C500] mb-3">▶ Section 02 / Programs</p>
        <h1 className="font-serif text-[44px] lg:text-[88px] leading-[0.92]">Four <span className="italic text-[#F2C500]">tracks</span>.</h1>
      </section>
      <section className="max-w-[1300px] mx-auto px-6 lg:px-12 py-12 space-y-3">
        {PROGRAMS.map((p, i) => (
          <motion.article key={p.code} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
            className="border border-white/15 bg-[#1A1A1A] p-6 lg:p-8 grid lg:grid-cols-[110px_1fr_180px_auto] gap-6 items-center hover:border-[#F2C500] transition-colors">
            <div>
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F2C500]">{p.code}</p>
              <p className="font-serif text-7xl lg:text-8xl text-[#F2C500] leading-none mt-1">{i + 1}</p>
            </div>
            <div>
              <h3 className="font-serif text-2xl lg:text-3xl leading-tight" dangerouslySetInnerHTML={{ __html: p.t }} />
              <p className="text-sm text-white/65 mt-2 leading-[1.65]" dangerouslySetInnerHTML={{ __html: p.d }} />
              <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#F2C500]/85 mt-3">▸ Avg result · {p.kpi}</p>
            </div>
            <div className="font-mono text-[11px] space-y-1">
              <p className="flex justify-between"><span className="text-white/45">Duration</span><span>{p.dur}</span></p>
              <p className="flex justify-between"><span className="text-white/45">Price</span><span className="text-[#F2C500] font-bold">{p.price}</span></p>
            </div>
            <button onClick={() => setPage('trial')} data-testid={`fit-program-${p.code}`} className="bg-[#F2C500] text-[#0A0A0A] px-5 py-3 font-mono text-[10px] tracking-[0.3em] uppercase hover:bg-white transition-colors">Start →</button>
          </motion.article>
        ))}
      </section>
    </div>
  );
}
